import React from "react";
import Block from "./Block";
import SectionLayout from "../../components/SectionLayout";
import data from "./data.js";

const Blocks = ({}) => {
  return (
    <SectionLayout
      sectionId="results"
      title="Empower your design process"
      description="Design beautiful, accessible and efficient user interfaces through continuous feedback."
    >
      {data.results.map((block, index) => (
        <Block
          key={index}
          index={index}
          title={block.title}
          content={block.content}
          image={block.image}
          left={index % 2}
          additional={block.additional}
        />
      ))}
    </SectionLayout>
  );
};

export default Blocks;
